import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './OrderSuccess.css';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const reason = new URLSearchParams(location.search).get('reason') || 'Ödeme işlemi tamamlanamadı.';

  return (
    <div className="order-success-container">
      <div className="order-success-card">
        <div className="error-icon">❌</div>
        <h2>Ödeme Başarısız</h2>
        <p style={{ color: '#666', marginBottom: '8px' }}>{reason}</p>
        <p style={{ color: '#999', fontSize: '14px' }}>Sepetinizdeki ürünler korunmaktadır, tekrar deneyebilirsiniz.</p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
          <button className="continue-shopping-btn" onClick={() => navigate('/checkout')}>
            Tekrar Dene
          </button>
          <button className="continue-shopping-btn" onClick={() => navigate('/sepet')} style={{ background: '#666' }}>
            Sepete Dön
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
